<template>
  <Modal
    class="tw-translate-y-[-50%] assessment-modal tw-max-w-[878px]"
    :visible="showRef"
    border-radius="4px"
    @close="handleCloseModal"
  >
    <ModalHeader
      :class="`modal-header`"
      :title="
        data && data.length === 1
          ? getComponentUiText(
              'app-component-assessment-duplicate-question-modal-header-title-1',
            )
          : `${getComponentUiText(
              'app-component-assessment-duplicate-questions-modal-header-title-1',
            )} (${data.length})`
      "
      @close="handleCloseModal(true)"
    />
    <div
      class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-self-stretch tw-p-[16px] md:tw-p-[40px] tw-bg-[#FFFFFF]"
    >
      <div class="tw-flex tw-items-start tw-flex-col">
        <div class="tw-flex tw-items-center">
          <span
            class="tw-text-[#211F58] tw-text-[16px] tw-not-italic tw-font-semibold tw-leading-[130%] tw-pr-[10px]"
          >
            {{
              getComponentUiText(
                "app-component-assessment-duplicate-question-modal-sub-title-1",
              )
            }}
          </span>
          <ButtonShowDuplicateAssessment
            :id-popover="data[0].checklistItemId"
            :custom-class="'tw-max-w-[470px]'"
            :classes="`tw-leading-[36px]`"
          >
            <div class="tw-p-[25px]">
              <div class="tw-text-[14px] tw-font-[500] tw-text-[#211F58]">
                {{
                  getComponentUiText(
                    "app-component-assessment-title-duplicate-1",
                  )
                }}
              </div>
            </div>
          </ButtonShowDuplicateAssessment>
        </div>

        <span
          class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]"
          >{{
            getComponentUiText(
              data && data.length === 1
                ? "app-component-assessment-duplicate-question-modal-sub-des-1"
                : "app-component-assessment-duplicate-questions-modal-sub-des-1",
            )
          }}</span
        >
      </div>
      <div class="duplicate-wrap">
        <div class="duplicate-item">
          <span
            class="tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins"
          >
            {{
              getComponentUiText(
                "app-component-assessment-duplicate-question-option-answers-1",
              )
            }}
          </span>
          <ToggleSwitch
            :is-checked="duplicateAnswers"
            :data-cy="`assessment-display-options-duplicate-item-1`"
            color="#2573E9"
            @update:is-checked="(value) => (duplicateAnswers = value)"
          />
        </div>
        <div class="duplicate-item">
          <span
            class="tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins"
          >
            {{
              getComponentUiText(
                "app-component-assessment-duplicate-question-option-attach-1",
              )
            }}
          </span>
          <ToggleSwitch
            :is-checked="duplicateAttachments"
            :data-cy="`assessment-display-options-2`"
            color="#2573E9"
            @update:is-checked="(value) => (duplicateAttachments = value)"
          />
        </div>
        <div class="duplicate-item">
          <span
            class="tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins"
          >
            {{
              getComponentUiText(
                "app-component-assessment-duplicate-question-option-recommen-1",
              )
            }}
          </span>
          <ToggleSwitch
            :is-checked="duplicateGroups"
            :data-cy="`assessment-display-options-2`"
            color="#2573E9"
            @update:is-checked="(value) => (duplicateGroups = value)"
          />
        </div>
        <div class="duplicate-item">
          <span
            class="tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-[500] tw-leading-[100%] tw-font-Poppins"
          >
            {{
              getComponentUiText(
                data && data.length === 1
                  ? "app-component-assessment-duplicate-question-option-exclude-1"
                  : "app-component-assessment-duplicate-questions-option-exclude-1",
              )
            }}
          </span>
          <ToggleSwitch
            :is-checked="setExcluded"
            :data-cy="`assessment-display-options-3`"
            color="#2573E9"
            @update:is-checked="(value) => (setExcluded = value)"
          />
        </div>
      </div>
      <div
        :class="`advanced-section ${
          showAdvanced ? `` : `advanced-section-open`
        }`"
      >
        <div class="advanced-section-heading" @click="collapseCategory">
          <div class="tw-flex-1 tw-flex align-items-center">
            <img src="@/assets/img/infor-warning.svg" />
            <span class="advanced-section-heading-title">
              {{
                getComponentUiText(
                  "app-component-assessment-duplicate-question-option-advanced-1",
                )
              }}
            </span>
          </div>
          <span>
            <img
              v-if="showAdvanced"
              class="advanced-section-icon-show"
              src="@/assets/img/arrow-down.svg"
            />
            <img
              v-else
              class="advanced-section-icon-hidden"
              src="@/assets/img/arrow-down.svg"
            />
          </span>
        </div>
        <div v-if="showAdvanced" class="advanced-section-form">
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mb-[5px]">
            <div class="tw-col-span-1 md:tw-col-span-1 tw-flex tw-items-center">
              <span class="advanced-section-form-field-title">{{
                getComponentUiText(
                  "app-component-assessment-duplicate-question-advanced-field-1",
                )
              }}</span>
            </div>
            <div
              class="tw-col-span-1 tw-mt-[10px] md:tw-mt-0 md:tw-col-span-1 tw-flex md:tw-justify-end"
            >
              <input
                v-model="description"
                :placeholder="
                  getComponentUiText(
                    'app-component-assessment-duplicate-question-option-advanced-des-placeholder-1',
                  )
                "
                :class="`advanced-section-form-input tw-w-auto lg:tw-w-[346px]`"
              />
            </div>
          </div>
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
            <div class="tw-col-span-1 md:tw-col-span-1 tw-flex tw-items-center">
              <span class="advanced-section-form-field-title">{{
                getComponentUiText(
                  "app-component-assessment-duplicate-question-option-advanced-update-org-1",
                )
              }}</span>
            </div>
            <div
              class="tw-col-span-1 tw-mt-[10px] md:tw-mt-0 md:tw-col-span-1 tw-flex md:tw-justify-end"
            >
              <input
                v-model="idPerTypeIdO2Type"
                :placeholder="
                  getComponentUiText(
                    'app-component-assessment-duplicate-question-option-advanced-update-org-placeholder-1',
                  )
                "
                :class="`advanced-section-form-input tw-w-auto lg:tw-w-[346px]`"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="tw-flex tw-flex-row tw-justify-end tw-items-center tw-w-full tw-mt-[16px] md:tw-mt-[40px]"
      >
        <b-button
          variant="primary"
          class="tw-w-fit tw-h-[39px] tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px] tw-border-2 tw-border-solid hover:!tw-border-[#0069d9]"
          type="submit"
          @click="handleCloseModal"
        >
          {{
            getComponentUiText(
              "app-component-assessment-duplicate-assessment-modal-button-cancel-1",
            )
          }}
        </b-button>
        <ButtonLoading
          :title="
            getComponentUiText(
              'app-component-assessment-duplicate-assessment-modal-button-duplicate-1',
            )
          "
          :is-loading="isLoading"
          @click-action="duplicateAssessment"
        />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, PropType, Ref } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonLoading from "../common/buttonLoading.vue";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Assessment } from "@/services/apiRoutes/routes";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { postDuplicateQuestion } from "@/services/assessment";
import store from "@/store";
import ToggleSwitch from "../common/toggleSwitch.vue";
import { successStatusCodes } from "@/utils/constants";
import get from "lodash/get";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  updateDataFucntion: {
    type: Function as PropType<(payload: any) => Promise<void>>,
    required: false,
    default: undefined,
  },
  checklistId: {
    type: String,
    required: true,
  },
  data: {
    type: Array as PropType<any[]>,
    required: false,
    default: () => [],
  },
});

let showRef = ref(props.show);

const isLoading = ref(false);
const showAdvanced: Ref<boolean> = ref(false);
const duplicateAnswers: Ref<boolean> = ref(false);
const duplicateAttachments: Ref<boolean> = ref(false);
const duplicateGroups: Ref<boolean> = ref(false);
const setExcluded: Ref<boolean> = ref(false);

const description: Ref<string> = ref("");
const idPerTypeIdO2Type: Ref<string> = ref("");

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

onMounted(() => {
  // autoResize();
});
const collapseCategory = () => (showAdvanced.value = !showAdvanced.value);

const emit = defineEmits(["update:show", "update:data", "update:success"]);

const handleCloseModal = async (isClickIcon = false) => {
  // if (!isClickIcon && (formModel.name || formModel.description)) return;

  showRef.value = false;
  emit("update:show", showRef.value);
};

const duplicateAssessment = async () => {
  try {
    isLoading.value = true;
    const checklistItems = props.data.map((item: any) => {
      return {
        checklistItemId: item.checklistItemId,
        duplicateAnswers: duplicateAnswers.value,
        duplicateAttachments: duplicateAttachments.value,
        duplicateGroups: duplicateGroups.value,
        setExcluded: setExcluded.value,
        ...(description.value != null &&
          description.value !== "" && { description: description.value }),
        ...(idPerTypeIdO2Type.value != null &&
          idPerTypeIdO2Type.value !== "" && {
            idPerTypeIdO2Type: idPerTypeIdO2Type.value,
          }),
      };
    });

    const body = {
      checklistId: props.checklistId,
      checklistItems: checklistItems,
    };

    const res = await postDuplicateQuestion(body);
    if (res.status !== successStatusCodes.OK) return;

    const newChecklist = get(res, "data.data.checklistItems", []);

    await store.dispatch("Assessment/updateChecklistAfterDuplicate", {
      checklistItems: newChecklist,
    });

    store.dispatch(
      "Assessment/fetchCheckListIdMetricsCompletion",
      props.checklistId,
    );

    store.dispatch(
      "Assessment/getChecklistMetricScoreCompletion",
      props.checklistId,
    );

    store.dispatch("Assessment/fetchCategories", {
      checklistId: props.checklistId,
      reload: false,
    });

    showSuccessToast(
      getComponentUiText(
        "app-component-assessment-duplicate-question-option-advanced-success-1",
      ),
    );

    emit("update:success", true);
    handleCloseModal();
  } catch (error: any) {
    showErrorAPI(error, Assessment.postDuplicateQuestion);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style lang="scss" scoped>
.main {
  border: 1px solid #eff0f1;
  background: rgba(239, 240, 241, 0.5);
  transition: all 0.3s ease-in-out;
}

textarea::placeholder {
  color: #b7b7b7;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

input::placeholder {
  color: #b7b7b7;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.auto-expand {
  width: 100%;
  overflow-y: hidden;
  resize: none;
  outline-color: #eff0f1;
  line-height: 18px;
  color: #231f20;
}

.invalid-message {
  font-size: 11px !important;
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: #f7553c !important;
  line-height: 130% !important;
  margin-top: 10px !important;
}
.duplicate-wrap {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin-top: 25px;
}
.duplicate-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.advanced-section {
  width: 100%;
  border-radius: 10px;
  margin-top: 20px;
  padding: 20px 25px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
  align-self: stretch;
  border: 1px solid #fff;
  background: var(
    --placeholder-orange-soft,
    linear-gradient(
      0deg,
      rgba(254, 154, 5, 0.15) 0%,
      rgba(254, 154, 5, 0.15) 100%
    ),
    #fff
  );
  &.advanced-section-open {
    padding: 3px 25px;
  }
}
.advanced-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.advanced-section-heading-title {
  color: #fe9a05;
  font-size: 11px;
  font-weight: 500;
  line-height: 130%;
  font-style: normal;
  padding-left: 10px;
}
.advanced-section-form {
  margin-top: 8px;
}
.advanced-section-form-field-title {
  color: #fe9a05;
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
  font-style: normal;
}
.advanced-section-form-input {
  height: 56px;
  border-radius: 6px;
  border: 1px solid #fe9a05;
  background: #fcfcfd;
  padding: 18px 20px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  &::placeholder {
    color: #b7b7b7;
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: normal;
  }
}
.advanced-section-icon-show {
  transform: rotate(180deg);
}
</style>
